import GoogleAnalytics from "../../googleAnalytics";
import {
  RedeemWalletClicked,
  SaveNewAddress
} from "../../googleAnalytics/type";
import { CancelOrderStart, CancelOrderSuccess, TrackOrder } from "./types";

class MyAccountAnalyticsService {
  // === Ecens events ===

  cancelOrderStart(payload: CancelOrderStart) {
    GoogleAnalytics.cancelOrderStart(payload);
  }
  cancelOrderSuccess(payload: CancelOrderSuccess) {
    GoogleAnalytics.cancelOrderSuccess(payload);
  }
  saveNewAddress(payload: SaveNewAddress) {
    GoogleAnalytics.saveNewAddress(payload);
  }
  redeemWalletClicked(payload: RedeemWalletClicked) {
    GoogleAnalytics.redeemWalletClicked(payload);
  }
  accountInfoSaved() {
    GoogleAnalytics.accountInfoSaved();
  }
  trackOrder(payload: TrackOrder) {
    GoogleAnalytics.trackOrder(payload);
  }

  // === Other events ===
}

const AccountAnalyticsEvent = new MyAccountAnalyticsService();
export default AccountAnalyticsEvent;
